import { MEDIUM_CONTAINER_WIDTH, MIDDLE_CONTAINER_WIDTH, SMALL_CONTAINER_WIDTH } from '../constants';

import { BreakpointRangeValue } from './types';

/* eslint-disable typescript-sort-keys/string-enum */
enum BreakpointRangeName {
    Phone = 'Phone',
    TabletPortrait = 'TabletPortrait',
    TabletLandscape = 'TabletLandscape',
    Desktop = 'Desktop',
}

export const BreakpointRange: Record<BreakpointRangeName, BreakpointRangeValue> = {
    [BreakpointRangeName.Phone]: {
        low: 0,
        high: SMALL_CONTAINER_WIDTH - 1,
    },
    [BreakpointRangeName.TabletPortrait]: {
        low: SMALL_CONTAINER_WIDTH,
        high: MIDDLE_CONTAINER_WIDTH - 1,
    },
    [BreakpointRangeName.TabletLandscape]: {
        low: MIDDLE_CONTAINER_WIDTH,
        high: MEDIUM_CONTAINER_WIDTH - 1,
    },
    [BreakpointRangeName.Desktop]: {
        low: MEDIUM_CONTAINER_WIDTH,
        // Safari, Opera and IE CSS inspector does not support numbers generated by NUMBER.MAX_SAFE_INTEGER and NUMBER.MAX_VALUE
        high: Math.pow(2, 15) - 1,
    },
};
